module.exports = __webpack_public_path__ + "static/_/src/config/PsMusicConfig/musics/cd1//Track_8_Story_1_Hello Lisa_.mp3";